import type {DedicatedTeam} from '~/types/legacy'
import type {Populated} from '~/types/populated'

export function useDedicatedTeam() {
  const sdk = usePayloadSdk()
  const route = useRoute()

  const fetch = async () => {
    const result = await sdk.findGlobal({
      slug: 'dedicatedTeamGlobal',
      depth: 4,
      draft: !!route.query.preview,
    })

    return result as Populated<DedicatedTeam>
  }

  return {fetch}
}
